import React from 'react';
import { D } from './FlowTokens';
import { IconChevronDown } from './FlowIcons';

export const SelectRow = ({ tag, items, value, onChange, fallback }) => {
  const selLabel = (arr, val, fb) => arr.find(v => v.dateiname === val)?.name || fb;
  
  return (
    <div style={{ position: 'relative', background: D.card, border: `1px solid ${D.border}`, borderRadius: 14, boxShadow: '0 1px 4px rgba(28,24,18,0.05)' }}>
      <select value={value} onChange={e => onChange(e.target.value)} style={{ position: 'absolute', inset: 0, opacity: 0, width: '100%', height: '100%', cursor: 'pointer', zIndex: 2 }}>
        {items.map(v => <option key={v.dateiname} value={v.dateiname}>{v.name}</option>)}
      </select>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 10, fontFamily: D.mono, fontWeight: 700, color: D.accent, background: 'rgba(140,58,31,0.09)', padding: '3px 8px', borderRadius: 6 }}>{tag}</span>
          <span style={{ fontSize: 14, color: D.text, fontWeight: 500 }}>{selLabel(items, value, fallback)}</span>
        </div>
        <IconChevronDown />
      </div>
    </div>
  );
};
